import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./components/Home.vue')
    },
    {
      path: '/public/q/n/c/:idCardNumber',
      name: 'queryNetUserCertificate',
      component: () => import('./components/QueryNetUserCertificate.vue')
    },
    {
      path: '/public/q/m/c/:licenseNumber',
      name: 'queryMerchantResultIndex',
      component: () => import('./components/QueryMerchantResultIndex.vue')
    },
    {
      path: '/public/HCCDetailsList/:type', // type为0，有效健康证明，type为1，无效健康证明
      name: 'HCCDetailsList',
      component: () => import('./components/HCCDetailsList.vue')
    }
  ]
})
